export const SnowEffect = ({ length = 30, className }: { length?: number; className?: string }) => {
  const snowflakes = Array.from({ length }, (_, i) => ({
    id: i,
    size: `${Math.random() * 1 + 0.5}vw`,
    left: `${Math.random() * 100}vw`,
    opacity: Math.random() * 0.3 + 0.8,
    animationDuration: `${10 + Math.random() * 10}s`,
    animationDelay: `-${Math.random() * 10}s`,
    blur: i % 4 === 0 ? 'blur(1px)' : 'none',
    startOffset: `${Math.random() * 20 - 10}vw`,
    endOffset: `${Math.random() * 20 - 10}vw`,
  }));

  return (
    <div className={className}>
      <style jsx>
        {`
          @keyframes snowfall {
            0% {
              transform: translate3d(var(--start-offset), 0, 0);
            }
            100% {
              transform: translate3d(var(--end-offset), 110vh, 0);
            }
          }
        `}
      </style>
      {snowflakes.map(snowflake => (
        <div
          key={snowflake.id}
          className="absolute bg-white rounded-full"
          style={
            {
              width: snowflake.size,
              height: snowflake.size,
              left: snowflake.left,
              top: '-5vh',
              filter: snowflake.blur,
              opacity: snowflake.opacity,
              animation: `snowfall ${snowflake.animationDuration} linear infinite`,
              animationDelay: snowflake.animationDelay,
              '--start-offset': snowflake.startOffset,
              '--end-offset': snowflake.endOffset,
              zIndex: 1000,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};
